var _a, _b;
import { __assign } from "tslib";
import { reduxKey } from './constants';
import { ACTION_TYPE_INITIALIZE } from './actionTypes';
var actionHandlers = (_a = {},
    _a[ACTION_TYPE_INITIALIZE] = function (state, action) { return (__assign(__assign({}, state), action.config)); },
    _a);
var reducers = (_b = {},
    _b[reduxKey] = function (state, action) {
        if (state === void 0) { state = {}; }
        if (!actionHandlers[action.type]) {
            return state;
        }
        return actionHandlers[action.type](state, action);
    },
    _b);
export default reducers;
//# sourceMappingURL=reducers.js.map